import { application } from "./application"

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import CropController from "./crop_controller"
application.register("crop", CropController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
